import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from "clsx";
import { Picture } from "../../components/Icons/Picture";
import { SIZE } from "../../types/size";
import styles from "./sk-Avatar.module.css";
const iconSize = {
    24: 12,
    48: 24,
    64: 32,
};
export const Avatar = ({ children, className, fallbackIcon: Icon = Picture, hasError = false, shape = "squared", size = 48, ...restProps }) => {
    const showDefaultIcon = !children || hasError;
    const mainClassNames = clsx(className, styles.main, {
        [styles[`main--${shape}`]]: !!shape,
        [styles[`main--fallback-icon`]]: showDefaultIcon,
        [styles[`main--size-${SIZE[size]}`]]: !!size,
    });
    return (_jsx("picture", { className: mainClassNames, ...restProps, children: showDefaultIcon ? _jsx(Icon, { size: iconSize[size] }) : children }));
};
Avatar.displayName = "Avatar";
//# sourceMappingURL=Avatar.js.map